module.exports = __webpack_public_path__ + "static/media/pin_subagenzie_highlighted.5cac5d33.png";